<template>
  <div class="col-auto mainNavigationContainer">
    <div class="wp_MainNavPosition">
      <div class="collapse navbar-collapse wp_MainNavPositionAlign" id="navbarColor01">
        <ul class="navbar-nav mr-auto">
          <user-authenticated v-if="isAuthenticated" :data="data"></user-authenticated>

            <un-authenticated-models
              :un-authenticated-user-nav-texts="data" v-else
            />
         <user-authenticated-accounts v-if="isAuthenticated" :data="data"></user-authenticated-accounts>

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UnAuthenticatedModels from '@/components/shared/widgets/UnAuthenticatedModels'
import UserAuthenticated from '@/components/shared/widgets/UserAuthenticated'
import UserAuthenticatedAccounts from '@/components/shared/widgets/UserAuthenticatedAccounts'
import { authenticationApi } from '../../../services/ApiServices/authenticationApi'

export default {
	props: {
		data: {
			type: Object
		}
	},
	name: 'authenticated-user-models',
	data () {
		return {

			profilePic: ''
		}
	},
	components: {
		UnAuthenticatedModels,
		UserAuthenticated,
		UserAuthenticatedAccounts
	},
	computed: {
		...mapGetters('user', [
			'getUserData',
			'getProfilePicture',
			'isAuthenticated'
		]),
		...mapGetters('siteData', [
			'getSelectedCountry',
			'getCountriesWithShipping'
		])
	},
	mounted () {
		this.profilePic = this.getUserData.image_url
	},
	methods: {
		logOut () {
			authenticationApi.logOut().then(res => {
				this.$router.push('/')
			})
			// this.$emit('logOutUser')
		},
		userRoutes (to) {
			this.$router.push({
				name: to
			})
		}
	},
	watch: {
		getUserData () {
			this.profilePic = this.getUserData.image_url
		}
	}
}
</script>
